import InfoIcon from './component'

export default InfoIcon
